import { RequirementReviewPolicy } from "@wingspanhq/wingspan-api-sdk";

import { convertFormApprovalDataToReviewStrategy } from "../../../CreateRequirementDefinitionForm/utils";

export const getReviewStrategyLabel = (
  payload: Parameters<typeof convertFormApprovalDataToReviewStrategy>[0]
): string => {
  const strategy = convertFormApprovalDataToReviewStrategy(payload);

  switch (strategy) {
    case RequirementReviewPolicy.ALWAYS_REQUIRED:
      return "Always required";
    case RequirementReviewPolicy.ON_FAIL:
      return "Required on fail";
    case RequirementReviewPolicy.NEVER_REQUIRED:
      return "Not required";
    default:
      return "Not required";
  }
};
